import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box
} from '@mui/material';

const ROLES = [
    { value: 'national_director', label: 'National Director' },
    { value: 'state_director', label: 'State Director' },
    { value: 'director', label: 'Director' },
    { value: 'staff', label: 'Staff' }
];

const AssignRoleDialog = ({ open, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        email: '',
        role: '',
        director_id: '',
        first_name: '',
        last_name: '',
        nickname: '',
        notes: '',
        state_ids: '',
        sport_ids: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        const payload = {
            ...formData,
            state_ids: formData.state_ids ? formData.state_ids.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id)) : [],
            sport_ids: formData.sport_ids ? formData.sport_ids.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id)) : [],
            director_id: formData.director_id ? parseInt(formData.director_id) : undefined
        };

        // Remove empty fields
        Object.keys(payload).forEach(key => {
            if (payload[key] === '' || payload[key] === undefined) {
                delete payload[key];
            }
        });

        onSubmit(payload);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Assign Role</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        label="Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        fullWidth
                        required
                        helperText="For director roles, must be @usssa.com, @usssa.org, or @r-nd.com"
                    />

                    <FormControl fullWidth required>
                        <InputLabel>Role</InputLabel>
                        <Select
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                            label="Role"
                        >
                            {ROLES.map(role => (
                                <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {(formData.role === 'director' || formData.role === 'state_director') && (
                        <TextField
                            label="Director ID"
                            name="director_id"
                            value={formData.director_id}
                            onChange={handleChange}
                            fullWidth
                            helperText="Optional. Will auto-lookup by email if not provided."
                        />
                    )}

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            label="First Name"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleChange}
                            fullWidth
                            helperText="Required for new users"
                        />
                        <TextField
                            label="Last Name"
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleChange}
                            fullWidth
                            helperText="Required for new users"
                        />
                    </Box>

                    <TextField
                        label="Nickname"
                        name="nickname"
                        value={formData.nickname}
                        onChange={handleChange}
                        fullWidth
                    />

                    <TextField
                        label="State IDs (comma separated)"
                        name="state_ids"
                        value={formData.state_ids}
                        onChange={handleChange}
                        fullWidth
                        placeholder="e.g. 1, 12, 45"
                    />

                    <TextField
                        label="Sport IDs (comma separated)"
                        name="sport_ids"
                        value={formData.sport_ids}
                        onChange={handleChange}
                        fullWidth
                        placeholder="e.g. 11, 17"
                    />

                    <TextField
                        label="Notes"
                        name="notes"
                        value={formData.notes}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        rows={3}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">Assign</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AssignRoleDialog;
